module.exports = __webpack_public_path__ + "static/error-ig-2-b244da44507364100cef63801c5a5f78.png";